export const MEASUREMENT_ID = "G-CG16QLQ1C0";

export function trackGenerateLead() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }
  window.gtag("event", "generate_lead", { method: "website_form" });
  return true;
}
